import { v4 as uuidv4 } from 'uuid';
import popularNowData from './data/popular-now-publishers.json';

function getPopularNowPublishers() {
    this.popularNowPublishers = popularNowData.publishers;
    this.observed.popularNowPublishers = uuidv4();
}

export default getPopularNowPublishers;
